import { supabase } from "@/integrations/supabase/client";

export interface PaymentTransaction {
  id: string;
  userId: string;
  subscriptionId: string;
  revolutOrderId: string;
  revolutPublicId: string | null;
  amount: number;
  currency: string;
  tier: string;
  status: string;
  paymentMethod: string | null;
  errorMessage: string | null;
  webhookReceivedAt: Date | null;
  createdAt: Date;
  updatedAt: Date;
  completedAt: Date | null;
}

export const getPaymentHistory = async (): Promise<PaymentTransaction[]> => {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) return [];

  const { data, error } = await supabase
    .from('payment_transactions')
    .select('*')
    .eq('user_id', session.user.id)
    .order('created_at', { ascending: false });

  if (error) {
    console.error('Error fetching payment history:', error);
    return [];
  }

  return (data || []).map(tx => ({
    id: tx.id,
    userId: tx.user_id,
    subscriptionId: tx.subscription_id,
    revolutOrderId: tx.revolut_order_id,
    revolutPublicId: tx.revolut_public_id,
    amount: tx.amount,
    currency: tx.currency,
    tier: tx.tier,
    status: tx.status,
    paymentMethod: tx.payment_method,
    errorMessage: tx.error_message,
    webhookReceivedAt: tx.webhook_received_at ? new Date(tx.webhook_received_at) : null,
    createdAt: new Date(tx.created_at),
    updatedAt: new Date(tx.updated_at),
    completedAt: tx.completed_at ? new Date(tx.completed_at) : null,
  }));
};
